import { useEffect, useState } from 'react';
import { fetchCMSData } from 'services/fetchCMSData';
import CreatorsListItem, { Creator } from './CreatorsListItem';

const CreatorsList = () => {
  const [creatorsList, setCreatorsList] = useState<Creator[]>([]);

  useEffect(() => {
    async function fetchCreatorsData() {
      const creatorsListData = await fetchCMSData('creators-list', {
        fields: 'data.creators',
      });
      setCreatorsList(creatorsListData.creators);
    }
    fetchCreatorsData();
  }, []);

  return (
    <div className="relative">
      <div className="nc-CreatorsList space-y-10">
        <div id="single-entry-content" className="!max-w-screen-md mx-auto">
          {!!creatorsList.length &&
            creatorsList.map((creator, index) => (
              <CreatorsListItem
                key={creator.email + index}
                companyName={creator.companyName}
                contactName={creator.contactName}
                description={creator.description}
                email={creator.email}
                link={creator.link}
                type={creator.type}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default CreatorsList;
